module.exports = __webpack_public_path__ + "img/consulting.8e61af5d.jpg";